exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ta[data-v-574cd2b6]{width:100%;margin-bottom:0}@media (max-width:500px){.ta[data-v-574cd2b6]{font-size:17px;border-radius:0;min-height:30px;margin-bottom:0;width:calc(100% - 200px)}.ta.focused[data-v-574cd2b6]{height:80px}}", ""]);

// exports
